@if (!finished) {
  <div class="stepperContainer">
    <mat-stepper>

      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup" class="flexContainerColumn width50">
          <ng-template matStepLabel>Persönliche Informationen</ng-template>
          <div class="flexContainerRow">
            <div class="leftContainer">
              <mat-form-field appearance="fill">
                <mat-label>Name</mat-label>
                <input
                  matInput
                  formControlName="firstName"
                  placeholder="Name"
                  required />
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Nachname</mat-label>
                  <input
                    matInput
                    formControlName="lastName"
                    placeholder="Nachname"
                    required />
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                    <mat-label>Geburtstag</mat-label>
                    <input
                      matInput
                      [matDatepicker]="birthdayPicker"
                      formControlName="birthday"
                      placeholder="DD.MM.YYYY"
                      required />
                      <mat-datepicker-toggle
                        matSuffix
                      [for]="birthdayPicker"></mat-datepicker-toggle>
                      <mat-datepicker
                        #birthdayPicker
                      startView="multi-year"></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Geschlecht</mat-label>
                      <mat-select  formControlName="gender" required >
                        <mat-option value="0">männlich</mat-option>
                        <mat-option value="1">weiblich</mat-option>
                        <mat-option value="2">divers</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>E-Mail</mat-label>
                      <input matInput formControlName="email" required />
                      <mat-error>Ungültige E-Mail Adresse</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="rightContainer">
                    <mat-form-field appearance="fill">
                      <mat-label>Straße</mat-label>
                      <input matInput formControlName="street" required />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>Hausnummer</mat-label>
                      <input matInput formControlName="house" required />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>Postleitzahl</mat-label>
                      <input matInput formControlName="zip" required />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>Stadt</mat-label>
                      <input matInput formControlName="city" required />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>Telefon</mat-label>
                      <input matInput formControlName="phone" required/>
                    </mat-form-field>
                  </div>
                </div>
                <div class="flexContainerColumn whitebox big">
                  <p>Sie melden sich zum {{registrationDate | date:'dd.MM.yyyy' }} an</p>
                </div>
                <div class="flexContainerColumn whitebox big">
                  <mat-label>Welche Vertragsart wünschen Sie?</mat-label>
                  <mat-radio-group formControlName="contractType" aria-label="Welche Vertragsart wünschen Sie">
                    <div><mat-radio-button [disabled]="age !== undefined && age < 7" value="1"><strong>Flatrate</strong> - der Teilnehmer darf jede für seine Altersgruppe passende Unterrichtsstunde besuchen. Eine Begrenzung in der vom Teilnehmer besuchten Anzahl der Unterrichtsstunden pro Woche besteht nicht. Für Kinder bis 7 J. nicht möglich.</mat-radio-button></div>
                    <div><mat-radio-button [disabled]="age !== undefined && ((age > 6 && age < 18) || age <= 0)" value="2"><strong>Einzelkurs</strong> - der Teilnehmer besucht genau einen festgelegten Kurs, der 1x pro Woche stattfindet. Für Kinder bis 6 J. und für den Erwachsenen-Kurs ist nur diese Option möglich.</mat-radio-button></div>
                    <div><mat-radio-button [disabled]="age !== undefined && age < 8" value="3"><strong>Breakdance</strong> - der Teilnehmer besucht nur den Breakdance-Kurs, 1x die Woche, hierfür gibt es besondere Konditionen. Ab 8 J. möglich.</mat-radio-button></div>
                  </mat-radio-group>
                </div>

                <div class="flexContainerColumn whitebox">
                  <mat-checkbox formControlName="applicationConsent" required><span [innerHTML]="infoTextAufnahme"></span></mat-checkbox>
                  <br style="margin-bottom: 20px;">
                  <mat-checkbox formControlName="dataChangeConsent" required><span [innerHTML]="infoTextDataChange"></span></mat-checkbox>
                  <br style="margin-bottom: 20px;">
                  <mat-checkbox formControlName="privacyPolicyConsent" required><span [innerHTML]="infoTextPrivacyPolicy"></span></mat-checkbox>
                </div>
              </form>
              <div class="buttonsContainer">
                <button
                  mat-button
                  matStepperNext
                  [disabled]="firstFormGroup.status == 'INVALID'">
                  Weiter
                </button>
              </div>
            </mat-step>

            <mat-step [stepControl]="secondFormGroup">
              <form [formGroup]="secondFormGroup" class="flexContainerColumn width50">
                <ng-template matStepLabel>Zahlungsinformationen</ng-template>
                <div class="flexContainerRow">
                  <div class="leftContainer">
                    <mat-form-field appearance="fill">
                      <mat-label>Kontoinhaber</mat-label>
                      <input matInput formControlName="accountHolder" required />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>IBAN</mat-label>
                      <input matInput formControlName="iban" required/>
                    </mat-form-field>
                  </div>
                  <div class="rightContainer">
                    <mat-form-field appearance="fill">
                      <mat-label>BIC</mat-label>
                      <input matInput formControlName="bic" required />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>Name der Bank</mat-label>
                      <input matInput formControlName="bank" required />
                    </mat-form-field>
                  </div>
                </div>
                <div class="flexContainerColumn whitebox">
                  <mat-checkbox formControlName="directDebitConsent" required><span [innerHTML]="infoTextEinzugermaechtigung"></span></mat-checkbox>
                  <br style="margin-bottom: 20px;">
                  <mat-checkbox formControlName="returnDebitConsent" required><span [innerHTML]="infoTextReturnDebit"></span></mat-checkbox>
                </div>
              </form>
              <div class="buttonsContainer">
                <button mat-button matStepperPrevious class="backButton">Zurück</button>
                <button
                  mat-button
                  matStepperNext
                  [disabled]="secondFormGroup.status == 'INVALID'">
                  Weiter
                </button>
              </div>
            </mat-step>

            <mat-step>
              <form [formGroup]="thirdFormGroup" class="flexContainerColumn width50">
                <ng-template matStepLabel>Einwilligung</ng-template>
                <div class="flexContainerColumn whitebox">
                  <p [innerHTML]="infoTextEinwilligungserklaerung"></p>
                  <mat-checkbox formControlName="dataStorageConsent" required>Einwilligung zur Erhebung, Speicherung, Verarbeitung und Nutzung von personenbezogenen Daten</mat-checkbox>
                </div>
                <div class="flexContainerColumn whitebox">
                  <p [innerHTML]="infoTextEinverstaendniserklaerung"></p>
                  <mat-checkbox formControlName="multimediaConsent" required>Einverständniserklärung zur Nutzung von Bild- und Videomaterial</mat-checkbox>
                </div>
                @if (registrationPrice > 0) {
                  <div class="flexContainerColumn whitebox big">
                    <p>Ihr monatlicher Beitrag: {{registrationPrice | currency: 'EUR' }}</p>
                    <p>Ihr einmalige Anmeldegebühr: {{'15' | currency: 'EUR' }}</p>
                  </div>
                }
              </form>
              <div class="buttonsContainer">
                <button mat-button matStepperPrevious class="backButton">Zurück</button>
                <button
                  color="warn"
                  type="button"
                  matStepperNext
                  [disabled]="thirdFormGroup.status == 'INVALID'"
                  (click)="submit()"
                  >
                  Kostenpflichtig anmelden
                </button>
              </div>
            </mat-step>
          </mat-stepper>
        </div>
}
@if (finished) {
  <div class="finalizator">
  @if (!fatality) {
    <div class="flexContainerColumn">
      <div class="flexContainerColumn whitebox big message">
        <p>Registrierung erfolgreich abgeschlossen!</p>
        <p>Sie erhalten in Kürze eine Bestätigung per E-Mail</p>
        <p>Herzlich willkommen bei Li-Dance!</p>
      </div>
      <div class="buttonsContainer">
        <a mat-flat-button href="https://li-dance.de/li-dance-kursplan-aktuell-tanzschule-bad-nauheim.html">Zurück zur Li-Dance-Webseite</a>
      </div>
    </div>
  }
  @if (fatality) {
    <div class="flexContainerColumn">
      <div class="flexContainerColumn whitebox big message">
        <p>Bei der Registrierung ist leider ein Fehler aufgetreten!</p>
        <p>Bitte nehmen Sie direkten Kontakt mit uns auf</p>
        <p>Per Telefon, WhatsApp oder E-Mail</p>
      </div>
      <div class="buttonsContainer">
        <a mat-flat-button href="https://li-dance.de/li-dance-kontakt-tanzschule-bad-nauheim.html">Zu den Kontaktmöglichkeiten</a>
      </div>
    </div>
  }
  </div>
}
